import { Button } from 'component/Button'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { controller } from 'store/controller'
import { InferenceStore } from 'store/inference/InferenceStore'
import { store } from 'store/store'
import LookySvg from './asset/looky.svg'
import css from './LookyButton.module.scss'

type Props = {
  inference: InferenceStore
}

export const LookyButton = observer(({ inference }: Props) => {
  const onLink = useLatestCallback(() => {
    if (store.mobile) controller.openLookyFoo(inference)
    else controller.openBuy(inference)
  })

  return <Button className={css.button} gap={8} primary large wide action={onLink}>
    <LookySvg />
    <Typo size={15} medium upper>
      {i18n('ShareInLooky')}
    </Typo>
  </Button>
})
